<template>
  <div
    class="item-address"
    :class="{
      noEmpty:
        selectedAddress.addrid >= 0 ||
        (selectedAddress.regionid && selectedAddress.regionid !== '')
    }"
  >
    <div class="content-ui">
      <div
        class="content"
        @click="showAddress"
        v-if="selectedAddress.addrid >= 0"
      >
        <p class="address-text">
          {{ selectedAddress.province }}{{ selectedAddress.city
          }}{{ selectedAddress.district }}{{ selectedAddress.address }}
        </p>
        <p class="name-phone">
          {{ selectedAddress.name }}&nbsp;&nbsp;<span class="phone">{{
            selectedAddress.mobile
          }}</span>
        </p>
      </div>
      <div
        class="content"
        @click="showAddress"
        v-else-if="selectedAddress.regionid && selectedAddress.regionid !== ''"
      >
        <p class="empty-detail-address">
          {{ selectedAddress.province }}{{ selectedAddress.city
          }}{{ selectedAddress.district }}
        </p>
      </div>
      <div class="content" @click="showAddress" v-else>
        <p class="empty-detail-address"><i>地址</i><span>请选择地址</span></p>
      </div>
    </div>
    <div class="icon-ui">
      <i class="icon-arr-r"></i>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  inject: {
    changeAddrTrackParams: {
      default: null
    }
  },
  computed: {
    ...mapState([
      'workers',
      'selectedWorker',
      'selectedTime',
      'selectedAddress',
      'locationInfo',
      'viewName',
      'selectedCoupon',
      'confirmProduct',
      'confirmCoupons'
    ])
  },
  methods: {
    ...mapMutations([
      'showActionSheet',
      'changeView',
      'setActionHeader',
      'setSelectedWorker',
      'setSelectedTime',
      'setSelectedCoupon',
      'setConfirmCoupons',
      'resetConfirmCoupons'
    ]),
    showAddress() {
      this.changeView('confirmAddress')
      this.setActionHeader({
        title: '选择地址',
        show: false
      })
      // this.showActionSheet();
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
      // 埋点
      this.changeAddrTrackParams &&
        this.$$newTrackClick(this.changeAddrTrackParams)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.item-address {
  padding: rem(30px) rem(24px);
  margin-bottom: rem(20px);
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: rem(16px);
  &.noEmpty {
    background: url('~@/assets/images/bg-address@3x.png') no-repeat bottom;
    background-size: rem(702px) auto;
  }

  .content-ui {
    flex: auto;

    .address-text {
      font-size: rem(34px);
      color: #262626;
      letter-spacing: 0;
      line-height: rem(50px);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      font-weight: 600;
    }
    .name-phone {
      padding: rem(10px) 0;
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
      padding-bottom: rem(12px);
    }
  }
  .empty-detail-address {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      width: rem(200px);
      height: rem(36px);
      background: url('~@/assets/images/btn_daishouhuo _icon@3x.png') no-repeat
        left center;
      background-size: rem(27px) auto;
      line-height: rem(36px);
      font-size: rem(30px);
      color: #262626;
      padding-left: rem(40px);
    }
    span {
      line-height: rem(32px);
      font-size: rem(26px);
      color: #999;
    }
  }
  .icon-ui {
    flex: none;
    overflow: hidden;
    height: rem(36px);
    .icon-arr-r {
      height: 100%;
    }
  }
}
</style>
